import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import _ from "lodash";
import DatePicker from "react-datepicker";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import Select from "react-validation/build/select";
import Button from "react-validation/build/button";
import { NavLink, Redirect, Link } from "react-router-dom";
import {
  clearUpdate,
  getQualificationConfigurationByFormId,
  getAllDocumentChecklistByFormId,
  admissionAcademicProfileInsert,
  getAllQuota,
  getAllAdmissionProgramByFormId,
  getAllAdmissionFormConfigurationByFormId,
  getAllAdmissionSubjectGroupByFormId,
  getWorkingInstituteDetailsByStudentId,
  getOtherDetailsByStudentId,
  getResearchDetailsByStudentId,
  getExperienceDetailsByStudentId,
  getAcademicQuotaDetailsByStudentId,
  getFormVerifyDetailsByStudentId,
  getAllApplyThroughList,
  getAllBoardList,
  getAllMediumList,
  getAllMarksTypeList,
  getACPCdetailsByStudentId,
  getAllAdmissionFormListByStudentId,
  getStudentStatusDetailsByUserId,
  getInternshipDetails,
  getEntranceExaminationDetails,
  getDegreeRegistrationDetails,
  getAdmissionFormLookups,
  getNeetDetails,
} from "../../actions";
import updateGrid from "../../utils/updateGrid";
import * as validations from "../lib/validations";
import { FileInput } from "../lib/FileInputHOC";
import fileToBase64 from "../../utils/fileTobase64";
import SelectAdvance from "react-select";
import textToCapitalize from "../../utils/textToCapitalize";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { NotificationManager } from "react-notifications";

const keys = require("../../config/keys");

const getItemStyle = (isDragging, draggableStyle) => ({
  userSelect: "none",
  background: isDragging ? "antiquewhite" : "white",
  ...draggableStyle,
});
const getListStyle = (isDraggingOver) => ({
  background: isDraggingOver && "white",
});

const temp_entrance = {
  Id: 0,
  examId: 0,
  examName: "",
  rollNo: "",
  applicationNo: "",
  score: "",
  rankScored: "",
  selectedExam: null,
  IsDelete: 0,
};

const temp_internship = {
  Id: 0,
  fromDate: moment(),
  toDate: moment(),
  place: "",
  totalDays: 0,
  IsDelete: 0,
};

const temp_degree_reg = {
  Id: 0,
  degreeName: "",
  councilName: "",
  registrationNumber: "",
  IsDelete: 0,
  selectedCouncil: null,
  selectedDegree: null,
};

const temp_neet = {
  Id: 0,
  rollNo: "",
  allIndiaRank: 0,
  applicationNo: "",
  neetScore: 0,
  IsDelete: 0,
};

class AcademicInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allExperienceData: [],
      allResearchData: [],
      allDocumentList: [],
      allQualification: [],
      selectedPrograms: [],
      admissionProgram: [],
      allSubjectGroup: [],
      selectedQuota: [],
      academicQuota: [],
      entranceexaminationDetails: [],
      internshipDetails: [],
      degreeRegistrationDetails: [],
      admissionFormLookups: [],
      degreeReg: temp_degree_reg,
      internship: temp_internship,
      entrance: temp_entrance,
      neetDetails: temp_neet,
      admissionTypeId: 1,
      programRequired: false,
      selectedQuotaRequired: false,
      pcbm: "PCB",
      totalPCBM: 0,
      scoredPCBM: 0,
      pcbmPer: 0,
      degrewiseCouncilOpt: [],
      isNeetDetailMandatory:0
    };
    this.onDragEnd = this.onDragEnd.bind(this);
  }
  async componentWillMount() {
    this.props.getAllApplyThroughList();
    this.props.getAllBoardList();
    this.props.getAllMediumList();
    this.props.getAllMarksTypeList();

    // this.props.getAllAdmissionFormListByStudentId(this.props.auth.userId);
    // this.props.getStudentStatusDetailsByUserId(this.props.auth.userId);
    this.props.getAllAdmissionFormListByStudentId(
      this.props.auth.userId,
      this.props.auth.admissionConfig.AyId
    );
    this.props.getStudentStatusDetailsByUserId(
      this.props.auth.userId,
      this.props.auth.admissionConfig.AyId
    );

    const PromiseArry = [];

    if (this.props.FormId) {
      this.props.getAllAdmissionFormConfigurationByFormId(this.props.FormId);
      this.props.getAllQuota(this.props.FormId);
      PromiseArry.push(
        this.props.getFormVerifyDetailsByStudentId(
          this.props.FormId,
          this.props.auth.userId
        )
      );
      PromiseArry.push(
        this.props.getWorkingInstituteDetailsByStudentId(
          this.props.FormId,
          this.props.auth.userId
        )
      );
      PromiseArry.push(
        this.props.getOtherDetailsByStudentId(
          this.props.FormId,
          this.props.auth.userId
        )
      );
      PromiseArry.push(
        this.props.getResearchDetailsByStudentId(
          this.props.FormId,
          this.props.auth.userId
        )
      );
      PromiseArry.push(
        this.props.getExperienceDetailsByStudentId(
          this.props.FormId,
          this.props.auth.userId
        )
      );
      PromiseArry.push(
        this.props.getACPCdetailsByStudentId(
          this.props.FormId,
          this.props.auth.userId
        )
      );
      PromiseArry.push(
        this.props.getAllAdmissionSubjectGroupByFormId(
          this.props.FormId,
          this.props.auth.userId
        )
      );
      PromiseArry.push(
        this.props.getAllAdmissionProgramByFormId(
          this.props.FormId,
          this.props.auth.userId
        )
      );
      PromiseArry.push(
        this.props.getQualificationConfigurationByFormId(
          this.props.FormId,
          this.props.auth.userId
        )
      );
      PromiseArry.push(
        this.props.getAllDocumentChecklistByFormId(
          this.props.FormId,
          this.props.auth.userId
        )
      );
      PromiseArry.push(
        this.props.getAcademicQuotaDetailsByStudentId(
          this.props.FormId,
          this.props.auth.userId
        )
      );

      PromiseArry.push(
        this.props.getInternshipDetails(
          this.props.FormId,
          this.props.auth.userId
        )
      );

      PromiseArry.push(
        this.props.getEntranceExaminationDetails(
          this.props.FormId,
          this.props.auth.userId
        )
      );

      PromiseArry.push(
        this.props.getDegreeRegistrationDetails(
          this.props.FormId,
          this.props.auth.userId
        )
      );
      PromiseArry.push(
        this.props.getNeetDetails(this.props.FormId, this.props.auth.userId)
      );
      PromiseArry.push(this.props.getAdmissionFormLookups());
      await Promise.all(PromiseArry);

      // var otherdata = this.props.qualificationConfigList;
      var fromDataList = _.uniqBy(
        this.props.qualificationConfigList,
        "Qualification_ID"
      );
      var tempData = [];
      fromDataList.map((qual) => {
        var obj = { ...qual };
        var a = this.props.qualificationConfigList.filter(
          (i) =>
            i.Qualification_ID === qual.Qualification_ID &&
            i.ShowInDetailTable === 1
        );
        obj["subjectList"] = a;
        tempData.push(obj);
        return obj;
      });

      var subjectDataList = this.props.admissionSubjectGroupList.map((i) => {
        return i;
      });
    }

    var admissionProgram = this.props.admissionProgram.map((item) => {
      item.value = parseInt(item.CourseID, 10);
      item.label = item.ProgramName;
      item.disabled = item.AdmOpenCloseStatus ? true : false;
      item.clearableValue = item.AdmOpenCloseStatus ? false : true;
      return item;
    });

    var admTypeID;
    if (this.props.admissionProgram.length > 0) {
      admTypeID = this.props.admissionProgram[0].AdmissionType;
    }
    const t = this.props.admissionFormList.filter(
      (x) => x.ID === Number(this.props.FormId)
    );
    let academicQuota;
    if (
      t.length > 0 &&
      t[0].AdmissionFeesQuotaIds !== null &&
      t[0].AdmissionFeesQuotaIds !== ""
    ) {
      let atypeIds = t[0].AdmissionFeesQuotaIds.split(",").map(Number);

      if (atypeIds.length <= 0) {
        return _.map(this.props.quotaList, (data) => {
          return (
            <option key={data.Id} value={data.Id}>
              {data.ApplyName}
            </option>
          );
        });
      } else {
        academicQuota = _.sortBy(
          this.props.quotaList.filter((x) => atypeIds.includes(x.AdmQuotaId)),
          "AdmQuota"
        ).map((item) => {
          item.value = parseInt(item.AdmQuotaId, 10);
          item.label = item.AdmQuota;
          return item;
        });
      }
    } else {
      academicQuota = _.sortBy(this.props.quotaList, "AdmQuota").map((item) => {
        item.value = parseInt(item.AdmQuotaId, 10);
        item.label = item.AdmQuota;
        return item;
      });
    }

    var selectedQuota = _.sortBy(this.props.academicQuotaList, "AdmQuota").map(
      (item) => {
        item.value = parseInt(item.AdmQuotaId, 10);
        item.label = item.AdmQuota;
        return item;
      }
    );

    await this.setState((prev) => ({
      allDocumentList: _.sortBy(this.props.documentChecklist, "SeqNo"),
      allQualification: tempData,
      admissionProgram: admissionProgram,
      selectedPrograms: admissionProgram.filter((i) => parseInt(i.Id, 10)),
      allSubjectGroup: subjectDataList,
      selectedQuota: selectedQuota,
      admissionTypeId: admTypeID !== 0 ? admTypeID : 1,
      academicQuota: academicQuota,
      allExperienceData: this.props.admissionExperienceDetails,
      allResearchData: this.props.admissionResearchDetails,
      entranceexaminationDetails: this.props.entranceExaminationDetails,
      internshipDetails: this.props.internshipDetails,
      degreeRegistrationDetails: this.props.degreeRegistrationDetails,
      admissionFormLookups: this.props.admissionFormLookups,
      neetDetails: this.props.neetDetails,
      // internship:
      //   this.props.internshipDetails.length > 0
      //     ? {
      //         ...this.props.internshipDetails[0],
      //         fromDate: moment(this.props.internshipDetails[0].fromDate),
      //         toDate: moment(this.props.internshipDetails[0].toDate)
      //       }
      //     : prev.internshipDetails
    }));

    if (this.props.admissionACPCdetails.length > 0) {
      await this.setState({
        acpcId: this.props.admissionACPCdetails[0].Id,
        registrationNo: this.props.admissionACPCdetails[0].RegistrationNo,
        meritNo: this.props.admissionACPCdetails[0].MeritNo,
      });
    }
    if (this.props.admissionOtherDetails.length > 0) {
      await this.setState({
        isHostel:
          this.props.admissionOtherDetails[0].IsHostel === 1 ? true : false,
        isTransport:
          this.props.admissionOtherDetails[0].IsTransport === 1 ? true : false,
        otherDetailId: this.props.admissionOtherDetails[0].Id,
        proposedArea: this.props.admissionOtherDetails[0].ResearchArea_Title,
      });
    }
    if (this.props.admissionWorkingDetails.length > 0) {
      await this.setState({
        nameOfDepartment: this.props.admissionWorkingDetails[0].DepartmentName,
        institution: this.props.admissionWorkingDetails[0].InstituteName,
        dateOfAppointment:
          this.props.admissionWorkingDetails[0].AppointmentDate !== null
            ? moment(this.props.admissionWorkingDetails[0].AppointmentDate)
            : undefined,
        designation: this.props.admissionWorkingDetails[0].DesignationName,
        periodOfService: this.props.admissionWorkingDetails[0].ServicePeriod,
        isNOCenclosed:
          this.props.admissionWorkingDetails[0].IsNOCenclosed === 1
            ? true
            : false,
      });
    }

    const f =
      tempData.length > 0 &&
      tempData[0].subjectList.filter((x) =>
        [51, 52, 53].includes(x.Qual_SubjectID)
      );
    let totalPCBM = 0,
      scoredPCBM = 0,
      pcbm = tempData.length > 0 ? tempData[0].pcbm : "PCB";

    f &&
      f.forEach((x) => {
        totalPCBM += Number(x.MarksTotal_Theory);
        totalPCBM += Number(x.MarksTotal_Practical);
        scoredPCBM += Number(x.MarksScored_Theory);
        scoredPCBM += Number(x.MarksScored_Practical);
      });
    const pcbmPer = ((scoredPCBM / totalPCBM) * 100).toFixed(2);
    this.setState({ totalPCBM, scoredPCBM, pcbmPer, pcbm });
    // this is to check is neet details is mandatory
    try {
      const neetQualification = this.state.allQualification.find(
        (i) => i.Qualification_ID === 16 || i.Qualf_ShortName.toUpperCase() === "NEET"
      );
      const isNeetDetailMandatory = neetQualification.IsCompulsory  || 0;
      this.setState({ isNeetDetailMandatory });
      
    } catch (err) {
      this.setState({ isNeetDetailMandatory: 0 });
    }
  }

  /// Select DragDropContext
  reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };
  removeSelectedProgram = (index) => {
    this.state.selectedPrograms.splice(index, 1);
    this.setState({ selectedPrograms: this.state.selectedPrograms });
  };
  onDragEnd(result) {
    // dropped outside the list
    if (!result.destination) {
      return;
    }
    const selectedPrograms = this.reorder(
      this.state.selectedPrograms,
      result.source.index,
      result.destination.index
    );
    this.setState({
      selectedPrograms: selectedPrograms,
    });
  }

  handleQuotaChange = (selectedQuota) => {
    this.setState({ selectedQuota });
    if (selectedQuota.length) {
      this.setState({ selectedQuotaRequired: false });
    } else {
      this.setState({ selectedQuotaRequired: true });
    }
  };

  onSwitchToggle = (e) => {
    this.setState({ [e.target.name]: e.target.checked });
  };
  appointmentDate = (date) => {
    this.setState({
      dateOfAppointment: date,
    });
  };
  onInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  // ExperienceData
  addExperienceData = async (e) => {
    e.preventDefault();
    if (
      this.state.position !== undefined &&
      this.state.organisation !== undefined
    ) {
      var experienceDatas = this.state.allExperienceData.filter((item) => {
        return (
          item.Position.toLowerCase().trim() ===
            this.state.position.toLowerCase().trim() &&
          item.Organisation.toLowerCase().trim() ===
            this.state.organisation.toLowerCase().trim()
        );
      });
      if (experienceDatas.length === 0) {
        const experienceConfig = {
          Position: this.state.position,
          Organisation: this.state.organisation,
          WorkDetails: this.state.workDetails,
          WorkDuration: this.state.workDuration,
        };
        await this.setState({
          allExperienceData: [
            ...this.state.allExperienceData.filter(
              (item) =>
                item.Position.toLowerCase().trim() !==
                  this.state.position.toLowerCase().trim() ||
                item.Organisation.toLowerCase().trim() !==
                  this.state.organisation.toLowerCase().trim()
            ),
            experienceConfig,
          ],
        });
      }
    }
    await this.setState({
      position: "",
      organisation: "",
      workDetails: "",
      workDuration: "",
    });
  };

  addEntranceExam = () => {
    if (
      this.state.entrance.selectedExam === null ||
      this.state.entrance.rollNo === "" ||
      this.state.entrance.applicationNo === "" ||
      this.state.entrance.score === "" ||
      this.state.entrance.rankScored === ""
    ) {
      this.setState({ experiencedRequired: true });
    } else {
      const { Id } = this.state.entrance;
      const tmp = { ...this.state.entrance, Id: Id === 0 ? Math.random() : Id };
      const t = [...this.state.entranceexaminationDetails, tmp];
      this.setState({ entranceexaminationDetails: t, entrance: temp_entrance });
    }
  };

  deleteEntranceExam = (item) => {
    let d_entrance = this.state.entranceexaminationDetails.filter(
      (x) => x.Id !== item.Id
    );
    d_entrance.IsDelete = 1;

    const tmp = [
      ...this.state.entranceexaminationDetails.filter((x) => x.Id !== item.Id),
      d_entrance,
    ];
    this.setState({ entranceexaminationDetails: tmp });
  };

  addInternshipDetails = () => {
    if (
      this.state.internship.fromDate === "" ||
      this.state.internship.toDate === "" ||
      this.state.internship.place === "" ||
      this.state.internship.totalDays === "" ||
      this.state.internship.totalDays <=0
    ) {
      this.setState({ intershipRequired: true });
    } else {
      const { Id } = this.state.internship;
      const tmp = {
        ...this.state.internship,
        Id: Id === 0 ? Math.random() : Id,
      };
      const t = [...this.state.internshipDetails, tmp];
      this.setState({ internshipDetails: t, internship: temp_internship });
    }
  };

  deleteInternshipDetail = (item) => {
    let d_entrance = this.state.internshipDetails.filter(
      (x) => x.Id !== item.Id
    );
    d_entrance.IsDelete = 1;

    const tmp = [
      ...this.state.internshipDetails.filter((x) => x.Id !== item.Id),
      d_entrance,
    ];
    this.setState({ internshipDetails: tmp });
  };

  addDegreeRegistration = () => {
    if (
      this.state.degreeReg.degreeName === "" ||
      this.state.degreeReg.councilName === "" ||
      this.state.degreeReg.registrationNumber === ""
    ) {
      this.setState({ degreeRequired: true });
    } else {
      const { Id } = this.state.degreeReg;
      const tmp = {
        ...this.state.degreeReg,
        Id: Id === 0 ? Math.random() : Id,
      };
      const t = [...this.state.degreeRegistrationDetails, tmp];
      this.setState({
        degreeRegistrationDetails: t,
        degreeReg: temp_degree_reg,
      });
    }
  };

  deleteDegreeRegistration = (item) => {
    let d_entrance = this.state.degreeRegistrationDetails.filter(
      (x) => x.Id !== item.Id
    );
    d_entrance.IsDelete = 1;

    const tmp = [
      ...this.state.degreeRegistrationDetails.filter((x) => x.Id !== item.Id),
      d_entrance,
    ];
    this.setState({ degreeRegistrationDetails: tmp });
  };

  experienceConfigDelete = (eIndex) => {
    var array = this.state.allExperienceData;
    array.splice(eIndex, 1);
    this.setState({
      allExperienceData: array,
      position: "",
      organisation: "",
      workDetails: "",
      workDuration: "",
    });
  };

  // ResearchData
  addResearchData = async (e) => {
    e.preventDefault();
    if (
      this.state.publication !== undefined &&
      this.state.nameofJournal !== undefined &&
      this.state.researchType !== undefined
    ) {
      var researchDatas = this.state.allResearchData.filter((item) => {
        return (
          item.PublicationTitle.toLowerCase().trim() ===
          this.state.publication.toLowerCase().trim()
        );
      });
      if (researchDatas.length === 0) {
        const researchConfig = {
          PublicationTitle: this.state.publication,
          JournalName_Published: this.state.nameofJournal,
          No_Vol_Edition_Date: this.state.volEdition,
          ResearchType: this.state.researchType,
        };
        await this.setState({
          allResearchData: [
            ...this.state.allResearchData.filter(
              (item) =>
                item.PublicationTitle.toLowerCase().trim() !==
                this.state.publication.toLowerCase().trim()
            ),
            researchConfig,
          ],
        });
      }
    }
    await this.setState({
      publication: "",
      nameofJournal: "",
      volEdition: "",
      researchType: "",
    });
  };
  researchConfigDelete = (eIndex) => {
    var array = this.state.allResearchData;
    array.splice(eIndex, 1);
    this.setState({
      allResearchData: array,
      publication: "",
      nameofJournal: "",
      volEdition: "",
      researchType: "",
    });
  };

  onInputQualificationChange = (Qualification_ID, column, e) => {
    this.state.allQualification.filter(
      (i) => i.Qualification_ID === Qualification_ID
    )[0][column] = e.target.value;

    if (column === "PercentageOutOf") {
      var total_scoredMarks = this.state.allQualification.filter(
        (i) => i.Qualification_ID === Qualification_ID
      )[0]["overall_obtainedMarks"];
      var totalmarks = e.target.value;

      var overAllPercentage =
        (parseInt(total_scoredMarks) / parseInt(totalmarks)) * 100;

      if (parseInt(totalmarks) < parseFloat(total_scoredMarks)) {
        this.state.allQualification.filter(
          (i) => i.Qualification_ID === Qualification_ID
        )[0]["Percentage_Grade"] = "0.00";
      } else {
        this.state.allQualification.filter(
          (i) => i.Qualification_ID === Qualification_ID
        )[0]["Percentage_Grade"] = parseFloat(overAllPercentage).toFixed(2);
      }
    } else if (column === "overall_obtainedMarks") {
      // @@ to check dot value @@//

      var tempValue = e.target.value;

      tempValue = tempValue.toString();
      var isFloat = tempValue.includes(".");

      if (isFloat) {
        this.state.allQualification.filter(
          (i) => i.Qualification_ID === Qualification_ID
        )[0][column] = "";

        NotificationManager.warning("Only integer value accepted");
      }

      // @@ end

      const arrayToObj = {};
      // convert [{},{}] --> {};
      for (let i = 0; i < this.state.allQualification.length; i++) {
        Object.assign(arrayToObj, this.state.allQualification[i]);
      }

      if (arrayToObj.hasOwnProperty("PercentageOutOf")) {
        var total_marks = this.state.allQualification.filter(
          (i) => i.Qualification_ID === Qualification_ID
        )[0]["PercentageOutOf"];

        if (total_marks) {
          var overAllPercentage =
            (parseInt(e.target.value) / parseInt(total_marks)) * 100;

          if (parseInt(total_marks) < parseInt(e.target.value)) {
            this.state.allQualification.filter(
              (i) => i.Qualification_ID === Qualification_ID
            )[0]["Percentage_Grade"] = "0.00";
          } else {
            this.state.allQualification.filter(
              (i) => i.Qualification_ID === Qualification_ID
            )[0]["Percentage_Grade"] = isNaN(overAllPercentage)
              ? "0.00"
              : overAllPercentage.toFixed(2);
          }
        }
      }
    }

    this.setState({ refresh: !this.state.refresh });
  };

  onInputSubjectChange = (Qualification_ID, Qual_SubjectID, column, e) => {
    var filterQualification = this.state.allQualification.filter(
      (i) => i.Qualification_ID === Qualification_ID
    )[0];
    var filteredSubject = filterQualification.subjectList.filter(
      (i) => i.Qual_SubjectID === Qual_SubjectID
    )[0];
    filteredSubject[column] = e.target.value;

    filteredSubject["TotalMarks"] =
      parseInt(filteredSubject["MarksTotal_Theory"], 10) +
        parseInt(filteredSubject["MarksTotal_Practical"], 10) || 0;
    filteredSubject["TotalScored"] =
      parseInt(filteredSubject["MarksScored_Theory"], 10) +
        parseInt(filteredSubject["MarksScored_Practical"], 10) || 0;
    this.setState({ refresh: !this.state.refresh });

    const f = filterQualification.subjectList.filter((x) =>
      [51, 52, 53].includes(x.Qual_SubjectID)
    );
    let totalPCBM = 0,
      scoredPCBM = 0;

    f &&
      f.forEach((x) => {
        totalPCBM += Number(x.MarksTotal_Theory);
        totalPCBM += Number(x.MarksTotal_Practical);
        scoredPCBM += Number(x.MarksScored_Theory);
        scoredPCBM += Number(x.MarksScored_Practical);
      });
    const pcbmPer = ((scoredPCBM / totalPCBM) * 100).toFixed(2);
    this.setState({ totalPCBM, scoredPCBM, pcbmPer });
  };

  onInputSubjectGroupChange = (SubGroupId, column, e) => {
    this.state.allSubjectGroup.filter((i) => i.SubGroupId === SubGroupId)[0][
      column
    ] = e.target.value;

    this.setState({ refresh: !this.state.refresh });
  };

  handleFileBrowseChange = (index, e) => {
    e.persist();

    var file_size;
    if (e.target.files[0] && e.target.files[0].size !== undefined) {
      file_size = e.target.files[0].size;
    }
    var DocState = this.state.allDocumentList;
    if (file_size <= 512000) {
      fileToBase64(e).then((data) => {
        DocState[index].file = {
          file: data.file,
          fileName: data.name,
        };
        DocState[index].ref = this["file" + index];
        this.setState({ ["file" + index + "fileSize"]: file_size });
      });
    } else {
      DocState[index].file = {
        file: null,
        fileName: null,
      };
      this.setState({
        ["file" + index + "fileSize"]: file_size,
      });
    }
  };

  handleProgramsChange = (selectedPrograms) => {
    this.setState({ selectedPrograms });
    if (selectedPrograms.length) {
      this.setState({ programRequired: false });
    } else {
      this.setState({ programRequired: true });
    }
  };

  handleAdmissionTypeChange = (selectedOption) => {
    var objAdmissionType = this.props.admissionApplyThrough.filter(
      (item) => item.Id === parseInt(selectedOption.target.value, 10)
    );
    if (objAdmissionType.length > 0) {
      this.setState({
        admissionTypeId: selectedOption.target.value || 1,
        admissionType: objAdmissionType[0].ApplyName || "",
      });
    }
  };
  renderAdmissionType = () => {
    const t = this.props.admissionFormList.filter(
      (x) => x.ID === Number(this.props.FormId)
    );
    if (
      t.length > 0 &&
      t[0].AdmissionTypeIds !== null &&
      t[0].AdmissionTypeIds !== ""
    ) {
      let atypeIds = t[0].AdmissionTypeIds.split(",").map(Number);

      if (atypeIds.length <= 0) {
        return _.map(this.props.admissionApplyThrough, (data) => {
          return (
            <option key={data.Id} value={data.Id}>
              {data.ApplyName}
            </option>
          );
        });
      } else {
        return _.map(
          this.props.admissionApplyThrough.filter((x) =>
            atypeIds.includes(x.Id)
          ),
          (data) => {
            return (
              <option key={data.Id} value={data.Id}>
                {data.ApplyName}
              </option>
            );
          }
        );
      }
    }

    return _.map(this.props.admissionApplyThrough, (data) => {
      return (
        <option key={data.Id} value={data.Id}>
          {data.ApplyName}
        </option>
      );
    });
  };

  handleBoardChange = (Qualification_ID, column, e, University_Board) => {
    this.state.allQualification.filter(
      (i) => i.Qualification_ID === Qualification_ID
    )[0][column] = parseInt(e.target.value, 10);
    this.setState({ refresh: !this.state.refresh });
  };
  renderBoard = () => {
    return _.map(this.props.admissionBoard, (data) => {
      return (
        <option key={data.Id} value={data.Id}>
          {data.ShortName + " (" + data.BoardName + ")"}
        </option>
      );
    });
  };

  handleMediumChange = (Qualification_ID, column, e, Medium) => {
    this.state.allQualification.filter(
      (i) => i.Qualification_ID === Qualification_ID
    )[0][column] = e.target.value;
    this.setState({ refresh: !this.state.refresh });
  };
  renderMedium = () => {
    return _.map(this.props.admissionMedium, (data) => {
      return (
        <option key={data.Id} value={data.MediumName}>
          {data.MediumName}
        </option>
      );
    });
  };

  handleMarksTypeChange = (Qualification_ID, column, e, MarksTypeId) => {
    this.state.allQualification.filter(
      (i) => i.Qualification_ID === Qualification_ID
    )[0][column] = parseInt(e.target.value, 10);
    this.setState({ refresh: !this.state.refresh });
  };
  renderMarksType = () => {
    return _.map(this.props.admissionMarksType, (data) => {
      return (
        <option key={data.Id} value={data.Id}>
          {data.MarksType}
        </option>
      );
    });
  };

  onMonthPickerInputChange = (
    Qualification_ID,
    column,
    ename,
    PassingMonthYear
  ) => {
    this.state.allQualification.filter(
      (i) => i.Qualification_ID === Qualification_ID
    )[0][column] = ename;
    this.setState({ refresh: !this.state.refresh });
  };
  
  checkOtherDetailFlag=(internshipDet,degreeRegistrationDetails,entranceexaminationDetails)=>{


  const { admissionFormConfiguration } = this.props;
  const internshipTableLength = internshipDet.filter(
    (i) => i.IsDelete === 0
  ).length;
  const entranceExamDetailLength = entranceexaminationDetails.filter(
    (i) => i.IsDelete === 0
  ).length;
  const degreeRegLength = degreeRegistrationDetails.filter(
    (i) => i.IsDelete === 0
  ).length;

  const isInternshipDisp = admissionFormConfiguration.some(
    (i) => i.DisplayStatus === 1 && i.AdmFormGroupSectionId === 16
  );

  const isEntranceExamDisp = admissionFormConfiguration.some(
    (i) => i.DisplayStatus === 1 && i.AdmFormGroupSectionId === 17
  );

  const isDegreeDisp = admissionFormConfiguration.some(
    (i) => i.DisplayStatus === 1 && i.AdmFormGroupSectionId === 18
  );

  const IsConditionMatch =
    (!isInternshipDisp || internshipTableLength > 0) &&
    (!isEntranceExamDisp || entranceExamDetailLength > 0) &&
    (!isDegreeDisp || degreeRegLength > 0);

  const flag = !IsConditionMatch;
  return flag;


  }
  handleSubmit = (e) => {
    e.preventDefault();
    var isFormFeesPaidByStd = 0,
      isLocked = 0;

    var neetDetailFlag = false;
    if (this.state.isNeetDetailMandatory) {
      if (
        !["rollNo", "allIndiaRank", "applicationNo", "neetScore"].every(
          (value) => this.state.neetDetails.hasOwnProperty(value)
        )
      ) {
        NotificationManager.error("Neet Details Missing");
        neetDetailFlag = true;
      } else {
        Object.entries(this.state.neetDetails).map(([key, value]) => {
          if (value.length === 0) {
            NotificationManager.error("Neet Details Missing");
            neetDetailFlag = true;
          }
        });
      }
    }

    var objFormFeesPaidByStd = this.props.admissionStudentStatusDetails.filter(
      (i) => {
        return (
          parseInt(i.AdmFormGroupId, 10) === parseInt(this.props.FormId, 10)
        );
      }
    );
    if (objFormFeesPaidByStd.length > 0) {
      isFormFeesPaidByStd = objFormFeesPaidByStd[0].IsFormFeesPaid;
      isLocked = objFormFeesPaidByStd[0].IsLocked;
    }

    var allDocument = this.state.allDocumentList.filter((item) => item.file);
    allDocument.map((item) => {
      return (item.ref = null);
    });

    let qualification = this.state.allQualification;
    if (qualification.length > 0) {
      qualification[0].pcbm = this.state.pcbm;
      qualification[0].totalPCBM = this.state.totalPCBM;
      qualification[0].scoredPCBM = this.state.scoredPCBM;
      qualification[0].pcbmPer = isNaN(this.state.pcbmPer)
        ? 0
        : this.state.pcbmPer;
    }

    const temp_intern = [...this.state.internshipDetails];
    temp_intern.forEach((x) => {
      x.fromDate = moment(x.fromDate).format("YYYY-MM-DD");
      x.toDate = moment(x.toDate).format("YYYY-MM-DD");
    });

    var academicProfile = {
      StudentId: parseInt(this.props.auth.userId, 10),
      AdmFormId: parseInt(this.props.FormId, 10),
      ProgramsData: this.state.selectedPrograms.map((i, index) => {
        i.PreferredOrder = index + 1;
        return i;
      }),
      AdmissionType: parseInt(this.state.admissionTypeId, 10),
      OtherDetailId: this.state.otherDetailId,
      Qualification: qualification, // this.state.allQualification,
      SubjectGroup: this.state.allSubjectGroup,
      ExperienceData: this.state.allExperienceData,
      ResearchData: this.state.allResearchData,
      NameOfDepartment: this.state.nameOfDepartment,
      Institution: this.state.institution,
      DateOfAppointment:
        this.state.dateOfAppointment !== undefined
          ? moment(this.state.dateOfAppointment).format("YYYY-MM-DD")
          : null,
      InstituteId: this.props.admissionWorkingDetails.Id,
      Designation: this.state.designation,
      PeriodOfService: this.state.periodOfService,
      IsNOCenclosed: this.state.isNOCenclosed,
      ProposedArea: this.state.proposedArea,

      RegistrationNo: this.state.registrationNo,
      MeritNo: this.state.meritNo,
      acpcId: this.state.acpcId,
      ApplyAllQuota: this.state.selectedQuota,

      IsHostel: this.state.isHostel,
      IsTransport: this.state.isTransport,
      DocumentList: allDocument,
      IsActive: 1,
      IsDelete: false,
      CreatedBy: this.props.auth.userId,
      UpdatedBy: this.props.auth.userId,
      IsFormFeesPaid: isFormFeesPaidByStd,
      IsLocked: isLocked,
      // internship: {
      //   ...this.state.internship,
      //   fromDate: moment(this.state.internship.fromDate).format("YYYY-MM-DD"),
      //   toDate: moment(this.state.internship.toDate).format("YYYY-MM-DD")
      // },
      internshipDetails: temp_intern,
      degreeRegistrationDetails: this.state.degreeRegistrationDetails,
      entrance: this.state.entranceexaminationDetails,
      neet: this.state.neetDetails,
    };

    let quotaDisplay = 1;
    if (this.props.admissionFormConfiguration.filter((i) => i.DisplayStatus === 1 && i.AdmFormGroupSectionId === 6).length > 0) {
      quotaDisplay = 1;
    } else {
      quotaDisplay = 0;
    }
    const quotaRequired = ((quotaDisplay === 1 && this.state.selectedQuota.length > 0) || quotaDisplay === 0);

    if (
      this.state.selectedPrograms.length > 0 &&
      // this.state.selectedQuota.length > 0
      quotaRequired
    ) {
      var isError = [];
      isError = this.state.allQualification.find(
        (i) => parseInt(i.PercentageOutOf) < parseFloat(i.overall_obtainedMarks)
      );


    const otherDetailFlag=  this.checkOtherDetailFlag(temp_intern,this.state.degreeRegistrationDetails,this.state.entranceexaminationDetails)
      

      // if (isError) {
      //   NotificationManager.error("Calculate your marks properly");
      if (isError || neetDetailFlag || otherDetailFlag) {
        // NotificationManager.error("Calculate your marks properly");
        NotificationManager.error("Check all the mandatory fields ...!")
      } else {
        this.props.admissionAcademicProfileInsert(academicProfile);
        this.setState({ programRequired: false, selectedQuotaRequired: false });
      }


    } else {
      if (!(this.state.selectedPrograms.length > 0))
        this.setState({ programRequired: true });
      if (!(this.state.selectedQuota.length > 0))
        this.setState({ selectedQuotaRequired: true });
    }
  };

  componentDidUpdate() {
    updateGrid(this);
  }

  filterDropDownValue = (value) => {
    try {
      var filteredVal = this.state.admissionFormLookups.filter(
        (x) => x.type === "Council" && x.parenttype !== null
      );

      var degreeWisecouncilData = filteredVal.filter((i) =>
        i.parenttype.split(",").includes(value.shortName)
      );

      return degreeWisecouncilData;
    } catch (err) {
      return this.state.admissionFormLookups.filter(
        (x) => x.type === "Council"
      );
    }
  };

  render() {
    if (this.props.update.redirectTab) {
      return (
        <Redirect
          to={`/Account/StudentAccount/AdmissionForm/3/${this.props.FormId}`}
        />
      );
    }

    return (
      <div>
        <div className="main-bg">
          <Form
            onSubmit={this.handleSubmit.bind(this)}
            ref={(c) => {
              this.form = c;
            }}
            className="textTransCapitalize"
          >
            <p className="text-center mb-0">
              Rows marked with asterisk ( <label className="required" /> ) are
              mandatory
            </p>

            {this.props.admissionFormConfiguration.filter(
              (i) => i.DisplayStatus === 1 && i.AdmFormGroupSectionId === 1
            ).length > 0 && (
              <div>
                {this.state.admissionProgram.length > 0 && (
                  <div>
                    <h2 className="page-title sub-title">Preferred Courses</h2>
                    <div className="row">
                      <div className="form-group  col-sm-4 col-lg-3">
                        <label className="required">Admission Type</label>
                        <select
                          onChange={this.handleAdmissionTypeChange}
                          id="admissionTypeId"
                          name="admissionTypeId"
                          className="form-control"
                          value={this.state.admissionTypeId}
                          validations={[validations.requiredSelect]}
                          label="Gender"
                        >
                          {this.renderAdmissionType()}
                        </select>
                      </div>
                      <div className="form-group col-sm-8 col-lg-9">
                        <label className="required">
                          Select Courses{" "}
                          <span style={{ fontSize: "10px" }}>
                            (You can select Multiple Courses from the list
                            below)
                          </span>
                        </label>
                        <SelectAdvance
                          id="programId"
                          name="programId"
                          multi
                          className="advanceSelect"
                          onChange={this.handleProgramsChange}
                          label="Courses"
                          value={this.state.selectedPrograms}
                          options={this.state.admissionProgram}
                        />
                        {this.state.programRequired && (
                          <span className="require_field">
                            Program is Required
                          </span>
                        )}
                      </div>
                    </div>{" "}
                  </div>
                )}
                {this.state.selectedPrograms.length > 0 && (
                  <h5 className="draglist-title">
                    Set your preference in order{" "}
                    <small>(Drag Courses up/down to set order)</small>
                  </h5>
                )}
                {this.state.selectedPrograms.length > 0 && (
                  <div className="draglist-group">
                    <DragDropContext onDragEnd={this.onDragEnd}>
                      <Droppable droppableId="droppable">
                        {(provided, snapshot) => (
                          <div
                            ref={provided.innerRef}
                            style={getListStyle(snapshot.isDraggingOver)}
                          >
                            {this.state.selectedPrograms.map((item, index) => (
                              <Draggable
                                key={item.value}
                                draggableId={item.value}
                                index={index}
                                isDragDisabled={
                                  item.AdmOpenCloseStatus ? true : false
                                }
                              >
                                {(provided, snapshot) => (
                                  <div
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                    className="draglist-group-item"
                                    style={getItemStyle(
                                      snapshot.isDragging,
                                      provided.draggableProps.style
                                    )}
                                  >
                                    <i
                                      className="fa fa-bars"
                                      aria-hidden="true"
                                    />
                                    {item.label}
                                    <span className="badge badge-primary">
                                      {index + 1}
                                    </span>
                                    <i
                                      onClick={this.removeSelectedProgram.bind(
                                        this,
                                        index
                                      )}
                                      className="fa fa-remove float-right"
                                    />
                                  </div>
                                )}
                              </Draggable>
                            ))}
                            {provided.placeholder}
                          </div>
                        )}
                      </Droppable>
                    </DragDropContext>
                  </div>
                )}

                {_.sortBy(this.state.allQualification, "SeqNo").filter(
                  (i) => !i.IsCet
                ).length > 0 && (
                  <div className="mb-4">
                    <h2 className="page-title sub-title">
                      Enter Qualification Details
                    </h2>
                    <table className="table table-bordered qulification-table">
                      <thead className="table-light">
                        <tr>
                          <th
                            style={{ width: "180px" }}
                            className="align-middle"
                          >
                            Degree
                          </th>
                          <th
                            className="align-middle"
                            style={{ width: "100px" }}
                          >
                            Stream
                          </th>
                          <th
                            className="align-middle"
                            style={{ width: "90px" }}
                          >
                            {/* Month-Year */}
                            Month-Year of Passing
                          </th>
                          <th
                            className="align-middle"
                            style={{ width: "120px" }}
                          >
                            {/* Board */}
                            Board/University
                          </th>
                          <th
                            className="align-middle"
                            style={{ width: "190px" }}
                          >
                            {/* Institute/University */}
                            School/College
                          </th>

                          {/* medium_filed commited as per SumanDeep CtrlA Requirement Sheet updated 3 May 23 */}
                          {/* <th
                            className="align-middle"
                            style={{ width: "80px" }}
                          >
                            Medium
                          </th> */}

                          <th
                            className="align-middle"
                            style={{ width: "130px" }}
                          >
                            Marks Type
                          </th>

                          <th
                            className="align-middle"
                            style={{ width: "148px" }}
                          >
                            {/* Scored */}

                            {this.state.allQualification.some(
                              (i) =>
                                i.Qualification_ID === 10 ||
                                i.Qualification_ID === 11
                            ) ? (
                              <span> Total Marks Scored</span>
                            ) : (
                              <span>
                                {" "}
                                Final Year/ Semester
                                <br />
                                Marks Scored
                              </span>
                            )}
                          </th>
                          <th
                            className="align-middle"
                            style={{ width: "90px" }}
                          >
                            Max Marks
                          </th>

                          <th
                            className="align-middle"
                            style={{ width: "15px" }}
                          >
                            {/* Attempt */}
                            Percentage
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {_.sortBy(this.state.allQualification, "SeqNo")
                          .filter((i) => !i.IsCet)
                          .map((qualification, qualIndex) => {
                            if (
                              ![10, 11].includes(qualification.Qualification_ID)
                            ) {
                              this.state.allQualification.filter(
                                (i) =>
                                  i.Qualification_ID ===
                                  qualification.Qualification_ID
                              )[0]["StreamName"] = "N/A";
                            }
                            return (
                              <tr
                                key={qualIndex}
                                className="acInfoIsCompulsory"
                              >
                                <td className="align-middle">
                                  {qualification.IsCompulsory === 1 ? (
                                    <label className="required">
                                      {qualification.Adm_QualficationName}
                                    </label>
                                  ) : (
                                    <span>
                                      {qualification.Adm_QualficationName}
                                    </span>
                                  )}
                                </td>
                                <td className="align-middle">
                                  {[10, 11].includes(
                                    qualification.Qualification_ID
                                  ) && (
                                    <SelectAdvance
                                      id="StreamName"
                                      name="StreamName"
                                      className="advanceSelect"
                                      onChange={(opt) => {
                                        this.setState((prev) => ({
                                          selectedStreamName: opt,
                                        }));

                                        this.state.allQualification.filter(
                                          (i) =>
                                            i.Qualification_ID ===
                                            qualification.Qualification_ID
                                        )[0]["StreamName"] = opt.label;
                                      }}
                                      label="StreamName"
                                      value={{
                                        value: qualification.StreamName,
                                        label: qualification.StreamName,
                                      }}
                                      options={[
                                        { value: "Science", label: "Science" },
                                        {
                                          value: "Commerce",
                                          label: "Commerce",
                                        },
                                        { value: "Arts", label: "Arts" },
                                      ]}
                                    />
                                  )}
                                  {![10, 11].includes(
                                    qualification.Qualification_ID
                                  ) && `N/A`}
                                  {/* <input
                                    type="text"
                                    className="form-control"
                                    id="StreamName"
                                    name="StreamName"
                                    label="Stream"
                                    placeholder="Stream"
                                    value={qualification.StreamName || ""}
                                    onChange={this.onInputQualificationChange.bind(
                                      this,
                                      qualification.Qualification_ID,
                                      "StreamName"
                                    )}
                                  /> */}
                                </td>
                                <td className="align-middle ">
                                  <Input
                                    type="text"
                                    className={
                                      qualification.IsCompulsory === 1 &&
                                      !qualification.PassingMonthYear
                                        ? "form-control acInfoCompulsory"
                                        : "form-control"
                                    }
                                    id="PassingMonthYear"
                                    name="StreaPassingMonthYearmName"
                                    label="Month-Year"
                                    placeholder="MM/YYYY"
                                    validations={
                                      qualification.IsCompulsory
                                        ? [validations.required]
                                        : []
                                    }
                                    value={qualification.PassingMonthYear || ""}
                                    onChange={this.onInputQualificationChange.bind(
                                      this,
                                      qualification.Qualification_ID,
                                      "PassingMonthYear"
                                    )}
                                  />
                                </td>
                                <td className="align-middle">
                                  {![10, 11].includes(
                                    qualification.Qualification_ID
                                  ) ? (
                                    <Input
                                      type="text"
                                      className={
                                        qualification.IsCompulsory === 1 &&
                                        !qualification.InstituteName
                                          ? "form-control acInfoCompulsory"
                                          : "form-control"
                                      }
                                      id="University_Board"
                                      name="University_Board"
                                      label="University_Board"
                                      placeholder="University Name"
                                      value={
                                        qualification.University_Board == 0
                                          ? ""
                                          : qualification.University_Board || ""
                                      }
                                      validations={
                                        qualification.IsCompulsory
                                          ? [validations.required]
                                          : []
                                      }
                                      onChange={this.onInputQualificationChange.bind(
                                        this,
                                        qualification.Qualification_ID,
                                        "University_Board"
                                      )}
                                    />
                                  ) : (
                                    <Select
                                      onChange={this.handleBoardChange.bind(
                                        this,
                                        qualification.Qualification_ID,
                                        "University_Board"
                                      )}
                                      id="University_Board"
                                      name="University_Board"
                                      className={
                                        qualification.IsCompulsory === 1 &&
                                        parseInt(
                                          qualification.University_Board
                                        ) === 0
                                          ? "form-control acInfoCompulsory"
                                          : "form-control"
                                      }
                                      value={
                                        qualification.University_Board || 0
                                      }
                                      validations={
                                        qualification.IsCompulsory
                                          ? [validations.requiredSelect]
                                          : []
                                      }
                                      label="Board"
                                    >
                                      <option value="0">Select Board</option>
                                      {this.renderBoard()}
                                    </Select>
                                  )}
                                  {/* <Select
                                    onChange={this.handleBoardChange.bind(
                                      this,
                                      qualification.Qualification_ID,
                                      "University_Board"
                                    )}
                                    id="University_Board"
                                    name="University_Board"
                                    className={
                                      qualification.IsCompulsory === 1 &&
                                      parseInt(
                                        qualification.University_Board
                                      ) === 0
                                        ? "form-control acInfoCompulsory"
                                        : "form-control"
                                    }
                                    value={qualification.University_Board || 0}
                                    validations={
                                      qualification.IsCompulsory
                                        ? [validations.requiredSelect]
                                        : []
                                    }
                                    label="Board"
                                  >
                                    <option value="0">Select Board</option>
                                    {this.renderBoard()}
                                  </Select> */}
                                </td>
                                <td className="align-middle">
                                  <Input
                                    type="text"
                                    className={
                                      qualification.IsCompulsory === 1 &&
                                      !qualification.InstituteName
                                        ? "form-control acInfoCompulsory"
                                        : "form-control"
                                    }
                                    id="InstituteName"
                                    name="InstituteName"
                                    label="InstituteName"
                                    placeholder="Institute Name"
                                    value={qualification.InstituteName || ""}
                                    validations={
                                      qualification.IsCompulsory
                                        ? [validations.required]
                                        : []
                                    }
                                    onChange={this.onInputQualificationChange.bind(
                                      this,
                                      qualification.Qualification_ID,
                                      "InstituteName"
                                    )}
                                  />
                                </td>
                                {/* <td className="align-middle">
                                  <Input
                                    type="text"
                                    className={
                                      qualification.IsCompulsory === 1 &&
                                      !qualification.Medium
                                        ? "form-control acInfoCompulsory"
                                        : "form-control"
                                    }
                                    id="Medium"
                                    name="Medium"
                                    label="Medium"
                                    placeholder="Medium"
                                    value={qualification.Medium || ""}
                                    validations={
                                      qualification.IsCompulsory
                                        ? [validations.required]
                                        : []
                                    }
                                    onChange={this.onInputQualificationChange.bind(
                                      this,
                                      qualification.Qualification_ID,
                                      "Medium"
                                    )}
                                  />
                                </td> */}
                                {/* medium field commited as per SumanDeep CtrlA Requirement Sheet updated 3 May 23 */}
                                {/* <td className="align-middle">
                                  <Select
                                    onChange={this.handleMediumChange.bind(
                                      this,
                                      qualification.Qualification_ID,
                                      "Medium"
                                    )}
                                    id="Medium"
                                    name="Medium"
                                    className={
                                      qualification.IsCompulsory === 1 &&
                                      !qualification.Medium
                                        ? "form-control acInfoCompulsory"
                                        : "form-control"
                                    }
                                    value={qualification.Medium || ""}
                                    validations={
                                      qualification.IsCompulsory
                                        ? [validations.requiredSelect]
                                        : []
                                    }
                                    label="Medium"
                                  >
                                    <option value="">Select Medium</option>
                                    {this.renderMedium()}
                                  </Select>
                                </td> */}
                                <td className="align-middle">
                                  <Select
                                    onChange={this.handleMarksTypeChange.bind(
                                      this,
                                      qualification.Qualification_ID,
                                      "MarksTypeId"
                                    )}
                                    id="MarksTypeId"
                                    name="MarksTypeId"
                                    className={
                                      qualification.IsCompulsory === 1 &&
                                      parseInt(qualification.MarksTypeId) === 0
                                        ? "form-control acInfoCompulsory"
                                        : "form-control"
                                    }
                                    value={qualification.MarksTypeId || 0}
                                    validations={
                                      qualification.IsCompulsory
                                        ? [validations.requiredSelect]
                                        : []
                                    }
                                    label="MarksType"
                                  >
                                    <option value="0">Select MarksType</option>
                                    {this.renderMarksType()}
                                  </Select>
                                </td>
                                <td className="align-middle">
                                  <Input
                                    type="text"
                                    className={
                                      qualification.IsCompulsory === 1 &&
                                      !qualification.Percentage_Grade
                                        ? "form-control acInfoCompulsory"
                                        : "form-control"
                                    }
                                    id="overall_obtainedMarks"
                                    name="overall_obtainedMarks"
                                    label="Scored"
                                    placeholder="Scored"
                                    onKeyDown={(e) => {
                                      if (
                                        e.key === "." ||
                                        (!/^[0-9\b]+$/.test(e.key) &&
                                          e.key !== "Backspace")
                                      ) {
                                        e.preventDefault();
                                      }
                                    }}
                                    value={
                                      qualification.overall_obtainedMarks || ""
                                    }
                                    validations={
                                      qualification.IsCompulsory
                                        ? [validations.required]
                                        : []
                                    }
                                    onChange={this.onInputQualificationChange.bind(
                                      this,
                                      qualification.Qualification_ID,
                                      "overall_obtainedMarks"
                                    )}
                                  />
                                </td>
                                <td className="align-middle">
                                  <input
                                    type="number"
                                    className="form-control"
                                    id="PercentageOutOf"
                                    name="PercentageOutOf"
                                    label="Max Marks"
                                    placeholder="Max Marks"
                                    value={
                                      parseInt(
                                        Math.round(
                                          qualification.PercentageOutOf
                                        )
                                      ) || ""
                                    }
                                    onChange={this.onInputQualificationChange.bind(
                                      this,
                                      qualification.Qualification_ID,
                                      "PercentageOutOf"
                                    )}
                                  />
                                </td>
                                <td className="align-middle">
                                  <Input
                                    type="text"
                                    className={
                                      qualification.IsCompulsory === 1 &&
                                      !qualification.Attempts
                                        ? "form-control acInfoCompulsory"
                                        : "form-control"
                                    }
                                    id="Percentage_Grade"
                                    name="Percentage_Grade"
                                    label="Percentage_Grade"
                                    placeholder="#percentage"
                                    disabled={true}
                                    // value={qualification.Attempts || ""}
                                    value={
                                      qualification.Percentage_Grade + "%" || ""
                                    }
                                    validations={
                                      qualification.IsCompulsory
                                        ? [validations.required]
                                        : []
                                    }
                                    onChange={this.onInputQualificationChange.bind(
                                      this,
                                      qualification.Qualification_ID,
                                      "Attempts"
                                    )}
                                  />
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                    <hr />
                  </div>
                )}

                {_.sortBy(this.state.allQualification, "SeqNo").filter(
                  (i) => !i.IsCet && i.ShowInDetailTable === 1
                ).length > 0 && (
                  <div>
                    {_.sortBy(this.state.allQualification, "SeqNo")
                      .filter((i) => !i.IsCet && i.ShowInDetailTable === 1)
                      .map((qualification, qualIndex) => {
                        return (
                          <div key={qualIndex}>
                            <h5 className="inner-title mb-3 mt-2">
                              {qualification.Adm_QualficationName} Subject
                              Details{" "}
                              {/* <strong>
                                (In marks cards containing non segregated theory
                                &amp; practical marks, enter total marks in
                                theory field &amp; '0' in practical field)
                              </strong> */}
                              <strong>
                                (In marks cards containing non segregated theory
                                &amp; practical marks, enter total marks in
                                theory field &amp; 'Leave blank' in practical
                                field)
                              </strong>
                            </h5>
                            <table className="table table-bordered qulification-table">
                              <thead className="table-light">
                                <tr>
                                  <th
                                    rowSpan="2"
                                    className="align-middle"
                                    style={{ width: "250px" }}
                                  >
                                    Subjects
                                  </th>
                                  <th
                                    colSpan="2"
                                    className="align-middle text-center"
                                  >
                                    Theory
                                  </th>
                                  <th
                                    colSpan="2"
                                    className="align-middle text-center"
                                  >
                                    Practical
                                  </th>
                                  <th
                                    rowSpan="2"
                                    className="align-middle text-center"
                                    style={{ width: "160px" }}
                                  >
                                    Total
                                  </th>
                                </tr>
                                <tr className="text-center">
                                  <th className="align-middle">Max Marks</th>
                                  <th className="align-middle">Marks Scored</th>
                                  <th className="align-middle">Max Marks</th>
                                  <th className="align-middle">Marks Scored</th>
                                </tr>
                              </thead>
                              <tbody>
                                {qualification.subjectList.map(
                                  (subject, subjectIndex) => {
                                    return (
                                      <tr key={subjectIndex}>
                                        <td className="align-middle">
                                          {subject.Qual_Subjects ===
                                            "Biology" && (
                                            <Select
                                              className="form-control"
                                              onChange={(opt) => {
                                                subject.pcbm = opt.target.value;
                                                this.setState({
                                                  pcbm: opt.target.value,
                                                });
                                              }}
                                              id="pcbm"
                                              name="pcbm"
                                              value={this.state.pcbm}
                                              label=""
                                            >
                                              {[
                                                {
                                                  name: "Biology",
                                                  value: "PCB",
                                                },
                                                { name: "Maths", value: "PCM" },
                                              ].map((x) => (
                                                <option
                                                  key={x.value}
                                                  value={x.value}
                                                >
                                                  {x.name}
                                                </option>
                                              ))}
                                            </Select>
                                          )}
                                          {subject.Qual_Subjects !==
                                            "Biology" && subject.Qual_Subjects}
                                        </td>
                                        <td className="align-middle text-center">
                                          <input
                                            type="number"
                                            className="form-control"
                                            id="MarksTotal_Theory"
                                            name="MarksTotal_Theory"
                                            label="Max Marks"
                                            placeholder="Max Marks"
                                            value={
                                              Math.round(
                                                subject.MarksTotal_Theory
                                              ) || ""
                                            }
                                            onChange={this.onInputSubjectChange.bind(
                                              this,
                                              subject.Qualification_ID,
                                              subject.Qual_SubjectID,
                                              "MarksTotal_Theory"
                                            )}
                                          />
                                        </td>
                                        <td className="align-middle text-center">
                                          <input
                                            type="number"
                                            className="form-control"
                                            id="MarksScored_Theory"
                                            name="MarksScored_Theory"
                                            label="Max Scored"
                                            placeholder="Max Scored"
                                            value={
                                              Math.round(
                                                subject.MarksScored_Theory
                                              ) || ""
                                            }
                                            onChange={this.onInputSubjectChange.bind(
                                              this,
                                              subject.Qualification_ID,
                                              subject.Qual_SubjectID,
                                              "MarksScored_Theory"
                                            )}
                                          />
                                        </td>
                                        <td className="align-middle text-center">
                                          <input
                                            type="number"
                                            className="form-control"
                                            id="MarksTotal_Practical"
                                            name="MarksTotal_Practical"
                                            label="Max Marks"
                                            placeholder="Max Marks"
                                            value={
                                              Math.round(
                                                subject.MarksTotal_Practical
                                              ) || ""
                                            }
                                            onChange={this.onInputSubjectChange.bind(
                                              this,
                                              subject.Qualification_ID,
                                              subject.Qual_SubjectID,
                                              "MarksTotal_Practical"
                                            )}
                                          />
                                        </td>
                                        <td className="align-middle text-center">
                                          <input
                                            type="number"
                                            className="form-control"
                                            id="MarksScored_Practical"
                                            name="MarksScored_Practical"
                                            label="Max Scored"
                                            placeholder="Max Scored"
                                            value={
                                              Math.round(
                                                subject.MarksScored_Practical
                                              ) || ""
                                            }
                                            onChange={this.onInputSubjectChange.bind(
                                              this,
                                              subject.Qualification_ID,
                                              subject.Qual_SubjectID,
                                              "MarksScored_Practical"
                                            )}
                                          />
                                        </td>
                                        <td className="align-middle text-center">
                                          <input
                                            type="number"
                                            className="form-control"
                                            id="TotalScored"
                                            name="TotalScored"
                                            label="Total"
                                            placeholder="Total"
                                            value={
                                              Math.round(subject.TotalScored) ||
                                              ""
                                            }
                                            onChange={this.onInputSubjectChange.bind(
                                              this,
                                              subject.Qualification_ID,
                                              subject.Qual_SubjectID,
                                              "TotalScored"
                                            )}
                                          />
                                        </td>
                                      </tr>
                                    );
                                  }
                                )}
                              </tbody>
                              {this.state.allQualification.some(
                                (i) =>
                                  // i.Qualification_ID === 10 ||
                                  i.Qualification_ID === 11
                              ) && (
                                <tfoot className="table-light">
                                  <tr>
                                    <td
                                      colSpan={5}
                                      style={{ textAlign: "right" }}
                                    >{`${
                                      this.state.pcbm === null
                                        ? "PCB"
                                        : this.state.pcbm
                                    }%`}</td>
                                    <td>{`${
                                      isNaN(this.state.pcbmPer)
                                        ? "--"
                                        : this.state.pcbmPer
                                    }`}</td>
                                  </tr>
                                </tfoot>
                              )}
                            </table>
                          </div>
                        );
                      })}
                    <hr />
                  </div>
                )}

                {_.sortBy(this.state.allQualification, "SeqNo").filter(
                  (i) => i.IsCet
                ).length > 0 && (
                  <div>
                    <h2 className="page-title sub-title">
                      Enter Examination Details
                    </h2>
                    {_.sortBy(this.state.allQualification, "SeqNo")
                      .filter((i) => i.IsCet)
                      .map((qualification, qualIndex) => {
                        return (
                          <div key={qualIndex}>
                            <h5 className="inner-title mb-3 mt-1">
                              {qualification.Adm_QualficationName} Details
                            </h5>
                            <table className="table table-bordered qulification-table">
                              <thead className="table-light">
                                <tr>
                                  <th className="align-middle">Examination</th>
                                  <th className="align-middle">Reg. Number</th>
                                  <th className="align-middle">
                                    Marks Obtained
                                  </th>
                                  <th className="align-middle">Marks Out OF</th>
                                  <th className="align-middle">
                                    Percentile Score
                                  </th>
                                  <th className="align-middle">Rank</th>
                                  <th className="align-middle">
                                    Caste-Category Rank
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td className="align-middle">
                                    {qualification.IsCompulsory === 1 ? (	
                                      <label className="required">	
                                        {qualification.Adm_QualficationName}{" "}	
                                      </label>	
                                    ) : (	
                                      <span>	
                                        {qualification.Adm_QualficationName}	
                                      </span>	
                                    )}
                                  </td>
                                  <td className="align-middle">
                                    <Input
                                      type="text"
                                      className="form-control"
                                      id="seatNumber"
                                      name="seatNumber"
                                      label="seatNumber"
                                      placeholder="Reg. Number"
                                      value={qualification.SeatNo || ""}
                                      onChange={this.onInputQualificationChange.bind(
                                        this,
                                        qualification.Qualification_ID,
                                        "SeatNo"
                                      )}
                                      validations={	
                                        qualification.IsCompulsory	
                                          ? [validations.required]	
                                          : []	
                                      }
                                    />
                                  </td>
                                  <td className="align-middle">
                                    {/* <input
                                      type="number"
                                      className="form-control"
                                      id="Percentage_Grade"
                                      name="Percentage_Grade"
                                      label="Marks/Grade"
                                      placeholder="Marks Obtained"
                                      value={
                                        parseFloat(
                                          qualification.Percentage_Grade
                                        ) || ""
                                      }
                                      onChange={this.onInputQualificationChange.bind(
                                        this,
                                        qualification.Qualification_ID,
                                        "Percentage_Grade"
                                      )}
                                    /> */}
                                    <Input	
                                      type="number"	
                                      className="form-control"	
                                      id="overall_obtainedMarks"	
                                      name="overall_obtainedMarks"	
                                      label="Marks/Grade"	
                                      placeholder="Marks Obtained"	
                                      value={	
                                        parseFloat(	
                                          qualification.overall_obtainedMarks	
                                        ) || ""	
                                      }	
                                      onChange={this.onInputQualificationChange.bind(	
                                        this,	
                                        qualification.Qualification_ID,	
                                        "overall_obtainedMarks"	
                                      )}	
                                      validations={	
                                        qualification.IsCompulsory	
                                          ? [validations.required]	
                                          : []	
                                      }	
                                    />
                                  </td>
                                  <td className="align-middle">
                                    <Input
                                      type="number"
                                      className="form-control"
                                      id="PercentageOutOf"
                                      name="PercentageOutOf"
                                      label="Max Marks"
                                      placeholder="Marks Out OF"
                                      value={
                                        qualification.PercentageOutOf || ""
                                      }
                                      onChange={this.onInputQualificationChange.bind(
                                        this,
                                        qualification.Qualification_ID,
                                        "PercentageOutOf"
                                      )}
                                      validations={	
                                        qualification.IsCompulsory	
                                          ? [validations.required]	
                                          : []	
                                      }
                                    />
                                  </td>
                                  <td className="align-middle">
                                    <Input
                                      type="number"
                                      className="form-control"
                                      id="PercentileScore"
                                      name="PercentileScore"
                                      label="PercentileScore"
                                      placeholder="Percentile Score"
                                      value={qualification.Percentile || ""}
                                      onChange={this.onInputQualificationChange.bind(
                                        this,
                                        qualification.Qualification_ID,
                                        "Percentile"
                                      )}
                                      validations={	
                                        qualification.IsCompulsory	
                                          ? [validations.required]	
                                          : []	
                                      }
                                    />
                                  </td>
                                  <td className="align-middle">
                                    <Input
                                      type="number"
                                      className="form-control"
                                      id="AllIndiaRank"
                                      name="AllIndiaRank"
                                      label="All India Rank(Overall)"
                                      placeholder="Rank"
                                      value={qualification.Rank || ""}
                                      onChange={this.onInputQualificationChange.bind(
                                        this,
                                        qualification.Qualification_ID,
                                        "Rank"
                                      )}
                                      validations={	
                                        qualification.IsCompulsory	
                                          ? [validations.required]	
                                          : []	
                                      }
                                    />
                                  </td>
                                  <td className="align-middle">
                                    <Input
                                      type="number"
                                      className="form-control"
                                      id="CategoryRank"
                                      name="CategoryRank"
                                      label="Category Rank"
                                      placeholder="Caste-Category Rank"
                                      value={qualification.CategoryRank || ""}
                                      onChange={this.onInputQualificationChange.bind(
                                        this,
                                        qualification.Qualification_ID,
                                        "CategoryRank"
                                      )}
                                      validations={	
                                        qualification.IsCompulsory	
                                          ? [validations.required]	
                                          : []	
                                      }
                                    />
                                  </td>
                                </tr>
                              </tbody>
                            </table>

                            {qualification.IsCet &&
                              qualification.ShowInDetailTable === 1 && (
                                <div>
                                  <h5 className="inner-title mb-3 mt-2">
                                    {qualification.Adm_QualficationName} Subject
                                    Details{" "}
                                    {/* <strong>
                                      (In marks cards containing non segregated
                                      theory &amp; practical marks, enter total
                                      marks in theory field &amp; '0' in
                                      practical field)
                                    </strong> */}
                                    <strong>
                                      (In marks cards containing non segregated
                                      theory &amp; practical marks, enter total
                                      marks in theory field &amp; 'Leave blank'
                                      in practical field)
                                    </strong>
                                  </h5>
                                  <table className="table table-bordered qulification-table">
                                    <thead className="table-light">
                                      <tr>
                                        <th
                                          rowSpan="2"
                                          className="align-middle"
                                          style={{ width: "250px" }}
                                        >
                                          Subjects
                                        </th>
                                        <th className="align-middle text-center">
                                          Max Marks
                                        </th>
                                        <th className="align-middle text-center">
                                          Marks Scored
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {qualification.subjectList.map(
                                        (subject, subjectIndex) => {
                                          return (
                                            <tr key={subjectIndex}>
                                              <td className="align-middle">
                                                {qualification.IsCompulsory ===	
                                                  1 ? (	
                                                    <label className="required">	
                                                      {subject.Qual_Subjects}{" "}	
                                                    </label>	
                                                  ) : (	
                                                    <span>	
                                                      {subject.Qual_Subjects}	
                                                    </span>	
                                                  )}
                                              </td>
                                              <td className="align-middle">
                                                <Input
                                                  type="number"
                                                  className="form-control"
                                                  id="MarksTotal_Theory"
                                                  name="MarksTotal_Theory"
                                                  label="Max Marks"
                                                  placeholder="Max Marks"
                                                  value={
                                                    subject.MarksTotal_Theory ||
                                                    ""
                                                  }
                                                  onChange={this.onInputSubjectChange.bind(
                                                    this,
                                                    subject.Qualification_ID,
                                                    subject.Qual_SubjectID,
                                                    "MarksTotal_Theory"
                                                  )}
                                                  validations={	
                                                    qualification.IsCompulsory	
                                                      ? [validations.required]	
                                                      : []	
                                                  }
                                                />
                                              </td>
                                              <td className="align-middle">
                                                <Input
                                                  type="number"
                                                  className="form-control"
                                                  id="MarksScored_Theory"
                                                  name="MarksScored_Theory"
                                                  label="Max Scored"
                                                  placeholder="Max Scored"
                                                  value={
                                                    subject.MarksScored_Theory ||
                                                    ""
                                                  }
                                                  onChange={this.onInputSubjectChange.bind(
                                                    this,
                                                    subject.Qualification_ID,
                                                    subject.Qual_SubjectID,
                                                    "MarksScored_Theory"
                                                  )}
                                                  validations={	
                                                    qualification.IsCompulsory	
                                                      ? [validations.required]	
                                                      : []	
                                                  }
                                                />
                                              </td>
                                            </tr>
                                          );
                                        }
                                      )}
                                    </tbody>
                                  </table>
                                  <hr />
                                </div>
                              )}
                          </div>
                        );
                      })}
                  </div>
                )}

                {/* SubjectGroup List */}
                {this.state.allSubjectGroup.length > 0 && (
                  <div className="row">
                    <div className="col-sm-12">
                      <h5 className="inner-title mb-3 mt-1">
                        Subject Group Details
                      </h5>
                      <div className="row">
                        {this.state.allSubjectGroup.map(
                          (subjectGroup, subIndex) => {
                            return (
                              <div className="col-sm-4" key={subIndex}>
                                <table className="table table-bordered qulification-table">
                                  <thead className="table-light">
                                    <tr>
                                      <th
                                        className="align-middle"
                                        style={{ width: "250px" }}
                                      >
                                        Group
                                      </th>
                                      <th
                                        className="align-middle"
                                        style={{ width: "160px" }}
                                      >
                                        Total
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td className="align-middle">
                                        {subjectGroup.MeritSubjGroupName}
                                      </td>
                                      <td className="align-middle">
                                        <input
                                          type="number"
                                          className="form-control"
                                          id="TotalScored"
                                          name="TotalScored"
                                          label="Total"
                                          placeholder="Total"
                                          value={
                                            Math.round(
                                              subjectGroup.TotalScored
                                            ) || ""
                                          }
                                          onChange={this.onInputSubjectGroupChange.bind(
                                            this,
                                            subjectGroup.SubGroupId,
                                            "TotalScored"
                                          )}
                                        />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            );
                          }
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}

            {this.props.admissionFormConfiguration.filter(
              (i) => i.DisplayStatus === 1 && i.AdmFormGroupSectionId === 14
            ).length > 0 ||
            this.props.admissionFormConfiguration.filter(
              (i) => i.DisplayStatus === 1 && i.AdmFormGroupSectionId === 15
            ).length > 0 ? (
              <div>
                <h4 className="page-title sub-title">ACPC Details</h4>
                <div className="row ">
                  {this.props.admissionFormConfiguration.filter(
                    (i) =>
                      i.DisplayStatus === 1 && i.AdmFormGroupSectionId === 14
                  ).length > 0 && (
                    <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                      <div className="form-group">
                        <label>ACPC Registration No</label>
                        <input
                          type="text"
                          className="form-control"
                          id="registrationNo"
                          value={this.state.registrationNo || ""}
                          name="registrationNo"
                          label="ACPC Registration No"
                          onChange={this.onInputChange}
                        />
                      </div>
                    </div>
                  )}
                  {this.props.admissionFormConfiguration.filter(
                    (i) =>
                      i.DisplayStatus === 1 && i.AdmFormGroupSectionId === 15
                  ).length > 0 && (
                    <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                      <div className="form-group">
                        <label>ACPC Merit No</label>
                        <input
                          type="text"
                          className="form-control"
                          id="meritNo"
                          value={this.state.meritNo || ""}
                          name="meritNo"
                          label="ACPC Merit No"
                          onChange={this.onInputChange}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ) : (
              ""
            )}

            {this.props.admissionFormConfiguration.filter(
              (i) => i.DisplayStatus === 1 && i.AdmFormGroupSectionId === 19
            ).length > 0 && (
              <div>
                <h4 className="page-title sub-title">{`Neet Registration Details`}</h4>
                <div className="row mb-4">
                  <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      {/* <label>{`Roll No`}</label> */}
                      {this.state.isNeetDetailMandatory === 1 ? (
                        <label className="required">{`Roll No`}</label>
                      ) : (
                        <span>{`Roll No`}</span>
                      )}
                      <Input
                        type="text"
                        className="form-control"
                        id="rollNo"
                        value={this.state.neetDetails.rollNo || ""}
                        name="rollNo"
                        label="rollNo"
                        validations={
                          this.state.isNeetDetailMandatory === 1
                            ? [validations.required]
                            : []
                        }
                        onChange={(e) => {
                          const neetDetails = {
                            ...this.state.neetDetails,
                            rollNo: e.target.value.toUpperCase(),
                          };

                          this.setState((prev) => ({
                            neetDetails,
                          }));
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      {/* <label>{`All India Rank`}</label> */}
                      {this.state.isNeetDetailMandatory === 1 ? (
                        <label className="required">{`All India Rank`}</label>
                      ) : (
                        <span>{`All India Rank`}</span>
                      )}
                      <Input
                        type="number"
                        className="form-control"
                        id="allIndiaRank"
                        value={this.state.neetDetails.allIndiaRank || ""}
                        name="allIndiaRank"
                        label="allIndiaRank"
                        validations={
                          this.state.isNeetDetailMandatory === 1
                            ? [validations.required]
                            : []
                        }
                        onChange={(e) => {
                          const neetDetails = {
                            ...this.state.neetDetails,
                            allIndiaRank: e.target.value,
                          };

                          this.setState((prev) => ({
                            neetDetails,
                          }));
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      {/* <label>{`Application No`}</label> */}
                      {this.state.isNeetDetailMandatory === 1 ? (
                        <label className="required">{`Application No`}</label>
                      ) : (
                        <span>{`Application No`}</span>
                      )}
                      <Input
                        type="text"
                        className="form-control"
                        id="applicationNo"
                        value={this.state.neetDetails.applicationNo || ""}
                        name="applicationNo"
                        label="applicationNo"
                        validations={
                          this.state.isNeetDetailMandatory === 1
                            ? [validations.required]
                            : []
                        }
                        onChange={(e) => {
                          const neetDetails = {
                            ...this.state.neetDetails,
                            applicationNo: e.target.value.toUpperCase(),
                          };

                          this.setState((prev) => ({
                            neetDetails,
                          }));
                        }}
                      />
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      {/* <label>{`Neet Score`}</label> */}
                      {this.state.isNeetDetailMandatory === 1 ? (
                        <label className="required">{`Neet Score`}</label>
                      ) : (
                        <span>{`Neet Score`}</span>
                      )}
                      <Input
                        type="number"
                        className="form-control"
                        id="neetScore"
                        value={this.state.neetDetails.neetScore || ""}
                        name="neetScore"
                        label="neetScore"
                        validations={
                          this.state.isNeetDetailMandatory === 1
                            ? [validations.required]
                            : []
                        }
                        onChange={(e) => {
                          const neetDetails = {
                            ...this.state.neetDetails,
                            neetScore: e.target.value,
                          };
                          this.setState((prev) => ({
                            neetDetails,
                          }));
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}

            {this.props.admissionFormConfiguration.filter(
              (i) => i.DisplayStatus === 1 && i.AdmFormGroupSectionId === 16
            ).length > 0 && (
              <div>
                <h4 className="page-title sub-title">{`Internship Details`}</h4>
                <div className="row mb-4">
                  <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label className="required">{`From Date`}</label>
                      <DatePicker
                        selected={this.state.internship.fromDate}
                        onChange={(date) => {
                          const fd = moment(date);
                          const td = moment(this.state.internship.toDate);
                          const daysDiff = td.diff(fd, "days");

                          const internship = {
                            ...this.state.internship,
                            fromDate: date,
                            totalDays: daysDiff,
                          };

                          this.setState((prev) => ({
                            internship,
                          }));
                          this.setState((prev) => ({
                            internship: { ...prev.internship, fromDate: date },
                          }));
                        }}
                        showYearDropdown
                        showMonthDropdown
                        className="form-control"
                        label="Date Of Appointment"
                        dateFormat={this.props.systemConfig.DateFormat}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label className="required">{`To Date`}</label>
                      <DatePicker
                        selected={moment(this.state.internship.toDate)}
                        onChange={(date) => {
                          const fd = moment(this.state.internship.fromDate);
                          const td = moment(date);
                          const daysDiff = td.diff(fd, "days");

                          const internship = {
                            ...this.state.internship,
                            toDate: date,
                            totalDays: daysDiff,
                          };

                          this.setState((prev) => ({
                            internship,
                          }));
                        }}
                        showYearDropdown
                        showMonthDropdown
                        className="form-control"
                        label="Date Of Appointment"
                        dateFormat={this.props.systemConfig.DateFormat}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label className="required">{`Place`}</label>
                      <input
                        type="text"
                        className="form-control"
                        id="place"
                        value={this.state.internship.place}
                        name="place"
                        label="place"
                        onChange={(e) => {
                          const internship = {
                            ...this.state.internship,
                            place: textToCapitalize(e.target.value),
                          };

                          this.setState((prev) => ({
                            internship,
                          }));
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-lg-2 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label className="required">{`Total Days`}</label>
                      <input
                        type="text"
                        className="form-control"
                        id="totalDays"
                        disabled
                        value={this.state.internship.totalDays}
                        name="totalDays"
                        label="totalDays"
                        onChange={(e) => {
                          console.log(this.state.internship);
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-lg-1 col-md-12 col-sm-12 col-xs-12 flexMiddel flex15">
                    <button
                      type="button"
                      className="btn btn-success btn-md theme-btn"
                      onClick={() => this.addInternshipDetails()}
                    >
                      <i className="fa fa-plus" />
                      Add
                    </button>
                  </div>
                  <div className="col-lg-12">
                    <table className="table table-bordered qulification-table mb-0">
                      <thead>
                        <tr>
                          <td>{`From Date`}</td>
                          <td>{`To Date`}</td>
                          <td>{`Place`}</td>
                          <td>{`Total Days`}</td>
                          <td>{``}</td>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.internshipDetails
                          .filter((x) => x.IsDelete === 0)
                          .map((item) => (
                            <tr key={item.Id}>
                              <td>
                                {moment(item.fromDate).format("DD-MM-YYYY")}
                              </td>
                              <td>
                                {moment(item.toDate).format("DD-MM-YYYY")}
                              </td>
                              <td>{item.place}</td>
                              <td>{item.totalDays}</td>

                              <td className="text-center align-middle">
                                <button
                                  className="btn btn-xs btn-danger theme-btn"
                                  onClick={() =>
                                    this.deleteInternshipDetail(item)
                                  }
                                  type="button"
                                >
                                  <i className="fa fa-trash" />
                                </button>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}

            {this.props.admissionFormConfiguration.filter(
              (i) => i.DisplayStatus === 1 && i.AdmFormGroupSectionId === 17
            ).length > 0 && (
              <div>
                <h4 className="page-title sub-title">{`Entrance Examination Details`}</h4>
                <div className="row mb-4">
                  <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label className="required">{`Exam`}</label>
                      <SelectAdvance
                        id="examId"
                        name="examId"
                        className="advanceSelect"
                        onChange={(opt) =>
                          this.setState((prev) => ({
                            entrance: {
                              ...prev.entrance,
                              selectedExam: opt,
                              examId: 0,
                              examName: opt ? opt.label : opt,
                            },
                          }))
                        }
                        label="Exam"
                        value={this.state.entrance.selectedExam}
                        options={this.state.admissionFormLookups.filter(
                          (x) => x.type === "Exam"
                        )}
                      />
                      {this.state.entrance.selectedExam &&
                        this.state.entrance.selectedExam.label ===
                          "Any Other (Specify)" && (
                          <input
                            type="text"
                            className="form-control"
                            id="anyOther"
                            value={this.state.entrance.examName}
                            name="anyOther"
                            label="anyOther"
                            onChange={(e) => {
                              const entrance = {
                                ...this.state.entrance,
                                examName: e.target.value.toUpperCase(),
                              };
                              this.setState((prev) => ({
                                entrance,
                              }));
                            }}
                          />
                        )}
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label className="required">{`Roll No`}</label>
                      <input
                        type="text"
                        className="form-control"
                        id="rollNo"
                        value={this.state.entrance.rollNo}
                        name="rollNo"
                        label="rollNo"
                        onChange={(e) => {
                          const entrance = {
                            ...this.state.entrance,
                            rollNo: e.target.value.toUpperCase(),
                          };
                          this.setState((prev) => ({
                            entrance,
                          }));
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label className="required">{`Application No`}</label>
                      <input
                        type="text"
                        className="form-control"
                        id="applicationNo"
                        value={this.state.entrance.applicationNo}
                        name="applicationNo"
                        label="applicationNo"
                        onChange={(e) => {
                          const entrance = {
                            ...this.state.entrance,
                            applicationNo: e.target.value.toUpperCase(),
                          };

                          this.setState((prev) => ({
                            entrance,
                          }));
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-lg-1 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label className="required">{`Score`}</label>
                      <input
                        type="number"
                        className="form-control"
                        id="score"
                        value={this.state.entrance.score}
                        name="score"
                        label="score"
                        onChange={(e) => {
                          const entrance = {
                            ...this.state.entrance,
                            score: e.target.value,
                          };

                          this.setState((prev) => ({
                            entrance,
                          }));
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-lg-1 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label className="required">{`Rank`}</label>
                      <input
                        type="number"
                        className="form-control"
                        id="rankScored"
                        value={this.state.entrance.rankScored}
                        name="rankScored"
                        label="rankScored"
                        onChange={(e) => {
                          const entrance = {
                            ...this.state.entrance,
                            rankScored: e.target.value,
                          };

                          this.setState((prev) => ({
                            entrance,
                          }));
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-lg-1 col-md-12 col-sm-12 col-xs-12 flexMiddel flex15">
                    <button
                      type="button"
                      className="btn btn-success btn-md theme-btn"
                      onClick={() => this.addEntranceExam()}
                    >
                      <i className="fa fa-plus" />
                      Add
                    </button>
                  </div>
                  <div className="col-lg-12">
                    <table className="table table-bordered qulification-table mb-0">
                      <thead>
                        <tr>
                          <td>{`Exam`}</td>
                          <td>{`Roll No`}</td>
                          <td>{`Application No`}</td>
                          <td>{`Score`}</td>
                          <td>{`Rank`}</td>
                          <td>{``}</td>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.entranceexaminationDetails
                          .filter((x) => x.IsDelete === 0)
                          .map((item) => (
                            <tr key={item.Id}>
                              <td>{item.examName}</td>
                              <td>{item.rollNo}</td>
                              <td>{item.applicationNo}</td>
                              <td>{item.score}</td>
                              <td>{item.rankScored}</td>
                              <td className="text-center align-middle">
                                <button
                                  className="btn btn-xs btn-danger theme-btn"
                                  onClick={() => this.deleteEntranceExam(item)}
                                  type="button"
                                >
                                  <i className="fa fa-trash" />
                                </button>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}

            {this.props.admissionFormConfiguration.filter(
              (i) => i.DisplayStatus === 1 && i.AdmFormGroupSectionId === 18
            ).length > 0 && (
              <div>
                <h4 className="page-title sub-title">{`Degree Registration`}</h4>
                <div className="row mb-4">
                  <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label className="required">{`Degree Name`}</label>
                      <SelectAdvance
                        id="degreeName"
                        name="degreeName"
                        className="advanceSelect"
                        onChange={(opt) => {
                          this.setState((prev) => ({
                            degreeReg: {
                              ...prev.degreeReg,
                              degreeName: opt ? opt.value : opt,
                            },
                            degrewiseCouncilOpt: this.filterDropDownValue(opt),
                          }));
                        }}
                        label="Exam"
                        value={
                          this.state.degreeReg.degreeName === ""
                            ? null
                            : {
                                value: this.state.degreeReg.degreeName,
                                label: this.state.degreeReg.degreeName,
                              }
                        }
                        options={this.state.admissionFormLookups.filter(
                          (x) => x.type === "Degree"
                        )}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label className="required">{`Council Name`}</label>
                      <SelectAdvance
                        id="councilName"
                        name="councilName"
                        className="advanceSelect"
                        onChange={(opt) =>
                          this.setState((prev) => ({
                            degreeReg: {
                              ...prev.degreeReg,
                              councilName: opt ? opt.value : opt,
                              selectedCouncil: opt,
                            },
                          }))
                        }
                        label="Exam"
                        value={
                          this.state.degreeReg.councilName === ""
                            ? null
                            : {
                                value: this.state.degreeReg.councilName,
                                label: this.state.degreeReg.councilName,
                              }
                        }
                        // options={this.state.admissionFormLookups.filter(
                        //   (x) => x.type === "Council"
                        // )}
                        options={this.state.degrewiseCouncilOpt}
                      />
                      {this.state.degreeReg.selectedCouncil &&
                        this.state.degreeReg.selectedCouncil.label ===
                          "Any Other (Specify)" && (
                          <input
                            type="text"
                            className="form-control"
                            id="anyOther"
                            value={this.state.degreeReg.councilName}
                            name="anyOther"
                            label="anyOther"
                            onChange={(e) => {
                              const degreeReg = {
                                ...this.state.degreeReg,
                                councilName: e.target.value.toUpperCase(),
                              };
                              this.setState((prev) => ({
                                degreeReg,
                              }));
                            }}
                          />
                        )}
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label className="required">{`Registration No`}</label>
                      <input
                        type="text"
                        className="form-control"
                        id="registrationNumber"
                        value={this.state.degreeReg.registrationNumber}
                        name="registrationNumber"
                        label="registrationNumber"
                        onChange={(e) => {
                          const degreeReg = {
                            ...this.state.degreeReg,
                            registrationNumber: e.target.value.toUpperCase(),
                          };

                          this.setState((prev) => ({
                            degreeReg,
                          }));
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-lg-1 col-md-12 col-sm-12 col-xs-12 flexMiddel flex15">
                    <button
                      type="button"
                      className="btn btn-success btn-md theme-btn"
                      onClick={() => this.addDegreeRegistration()}
                    >
                      <i className="fa fa-plus" />
                      Add
                    </button>
                  </div>
                  <div className="col-lg-12">
                    <table className="table table-bordered qulification-table mb-0">
                      <thead>
                        <tr>
                          <td>{`Degree Name`}</td>
                          <td>{`Council Name`}</td>
                          <td>{`Registration Number`}</td>

                          <td>{``}</td>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.degreeRegistrationDetails
                          .filter((x) => x.IsDelete === 0)
                          .map((item) => (
                            <tr key={item.Id}>
                              <td>{item.degreeName}</td>
                              <td>{item.councilName}</td>
                              <td>{item.registrationNumber}</td>

                              <td className="text-center align-middle">
                                <button
                                  className="btn btn-xs btn-danger theme-btn"
                                  onClick={() =>
                                    this.deleteDegreeRegistration(item)
                                  }
                                  type="button"
                                >
                                  <i className="fa fa-trash" />
                                </button>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}

            {this.props.admissionFormConfiguration.filter(
              (i) => i.DisplayStatus === 1 && i.AdmFormGroupSectionId === 2
            ).length > 0 && (
              <div>
                <h4 className="page-title sub-title">Experience Details</h4>
                <div className="row mb-4">
                  <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label>Position</label>
                      <input
                        type="text"
                        className="form-control"
                        id="position"
                        value={textToCapitalize(this.state.position) || ""}
                        name="position"
                        label="Position"
                        onChange={this.onInputChange}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label>Organisation</label>
                      <input
                        type="text"
                        className="form-control"
                        id="organisation"
                        value={textToCapitalize(this.state.organisation) || ""}
                        name="organisation"
                        label="Organisation"
                        onChange={this.onInputChange}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label>Assignment</label>
                      <input
                        type="text"
                        className="form-control"
                        id="workDetails"
                        value={textToCapitalize(this.state.workDetails) || ""}
                        name="workDetails"
                        label="Assignment"
                        onChange={this.onInputChange}
                      />
                    </div>
                  </div>
                  <div className="col-lg-2 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label>Period</label>
                      <input
                        type="number"
                        className="form-control"
                        id="workDuration"
                        value={this.state.workDuration || ""}
                        name="workDuration"
                        label="Period"
                        onChange={this.onInputChange}
                      />
                    </div>
                  </div>
                  <div className="col-lg-1 flexMiddel flex15">
                    <button
                      type="button"
                      className="btn btn-success btn-md marg30 theme-btn"
                      onClick={this.addExperienceData.bind()}
                    >
                      <i className="fa fa-plus" />
                      Add
                    </button>
                  </div>
                  <div className="col-lg-12">
                    <table className="table table-bordered qulification-table mb-0">
                      <thead className="table-light">
                        <tr>
                          <th className="align-middle">Position</th>
                          <th className="align-middle">Organisation</th>
                          <th className="align-middle">Assignment</th>
                          <th className="align-middle">Period</th>
                          <th className="align-middle" width="50px">
                            Remove
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.allExperienceData.map((item, index) => {
                          return (
                            item.Position !== undefined && item.Position !== "",
                            item.Organisation !== undefined &&
                              item.Organisation !== "" &&
                              item.WorkDetails !== undefined &&
                              item.WorkDetails !== "",
                            item.WorkDuration !== undefined &&
                            item.WorkDuration !== "" ? (
                              <tr key={index}>
                                <td className="align-middle">
                                  {item.Position}
                                </td>
                                <td className="align-middle">
                                  {item.Organisation}
                                </td>
                                <td className="align-middle">
                                  {item.WorkDetails}
                                </td>
                                <td className="align-middle">
                                  {item.WorkDuration}
                                </td>
                                <td className="text-center align-middle">
                                  <button
                                    className="btn btn-xs btn-danger theme-btn"
                                    onClick={this.experienceConfigDelete.bind(
                                      this,
                                      index
                                    )}
                                    type="button"
                                  >
                                    <i className="fa fa-trash" />
                                  </button>
                                </td>
                              </tr>
                            ) : (
                              ""
                            )
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}
            {this.props.admissionFormConfiguration.filter(
              (i) => i.DisplayStatus === 1 && i.AdmFormGroupSectionId === 3
            ).length > 0 && (
              <div>
                <h4 className="page-title sub-title">
                  Research Details (If PHD)
                </h4>
                <div className="row mb-4">
                  <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label>Title/Publication </label>
                      <input
                        type="text"
                        className="form-control"
                        id="publication"
                        value={textToCapitalize(this.state.publication) || ""}
                        name="publication"
                        label="Publication"
                        onChange={this.onInputChange}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label>Name of Journal</label>
                      <input
                        type="text"
                        className="form-control"
                        id="nameofJournal"
                        value={textToCapitalize(this.state.nameofJournal) || ""}
                        name="nameofJournal"
                        label="Name of Journal"
                        onChange={this.onInputChange}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label>Vol/Edition </label>
                      <input
                        type="text"
                        className="form-control"
                        id="volEdition"
                        value={this.state.volEdition || ""}
                        name="volEdition"
                        label="Vol/Edition"
                        onChange={this.onInputChange}
                      />
                    </div>
                  </div>
                  <div className="col-lg-2 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label>National/International </label>
                      <input
                        type="text"
                        className="form-control"
                        id="researchType"
                        value={textToCapitalize(this.state.researchType) || ""}
                        name="researchType"
                        label="National/International"
                        onChange={this.onInputChange}
                      />
                    </div>
                  </div>
                  <div className="col-lg-1 flexMiddel flex15">
                    <button
                      type="button"
                      className="btn btn-success btn-md marg30 theme-btn"
                      onClick={this.addResearchData.bind()}
                    >
                      <i className="fa fa-plus" />
                      Add
                    </button>
                  </div>
                  <div className="col-lg-12">
                    <table className="table table-bordered qulification-table mb-0">
                      <thead className="table-light">
                        <tr>
                          <th className="align-middle">Title/Publication</th>
                          <th className="align-middle">Name of Journal</th>
                          <th className="align-middle">Vol/Edition</th>
                          <th className="align-middle">
                            National/International
                          </th>
                          <th className="align-middle" width="50px">
                            Remove
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.allResearchData.map((item, index) => {
                          return (
                            item.PublicationTitle !== undefined &&
                              item.PublicationTitle !== "",
                            item.JournalName_Published !== undefined &&
                              item.JournalName_Published !== "",
                            item.No_Vol_Edition_Date !== undefined &&
                              item.No_Vol_Edition_Date !== "",
                            item.ResearchType !== undefined &&
                            item.ResearchType !== "" ? (
                              <tr key={index}>
                                <td className="align-middle">
                                  {item.PublicationTitle}
                                </td>
                                <td className="align-middle">
                                  {item.JournalName_Published}
                                </td>
                                <td className="align-middle">
                                  {item.No_Vol_Edition_Date}
                                </td>
                                <td className="align-middle">
                                  {item.ResearchType}
                                </td>
                                <td className="text-center align-middle">
                                  <button
                                    className="btn btn-xs btn-danger theme-btn"
                                    onClick={this.researchConfigDelete.bind(
                                      this,
                                      index
                                    )}
                                    type="button"
                                  >
                                    <i className="fa fa-trash" />
                                  </button>
                                </td>
                              </tr>
                            ) : (
                              ""
                            )
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}

            {this.props.admissionFormConfiguration.filter(
              (i) => i.DisplayStatus === 1 && i.AdmFormGroupSectionId === 3
            ).length > 0 && (
              <div className="mb-3">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="form-group">
                      <label>
                        Proposed Research Area / Title for Ph.D Studies
                      </label>
                      <textarea
                        type="text"
                        rows="3"
                        className="form-control"
                        id="proposedArea"
                        name="proposedArea"
                        label="Proposed Research Area / Title for Ph.D Studies"
                        value={textToCapitalize(this.state.proposedArea) || ""}
                        onChange={this.onInputChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
            {this.props.admissionFormConfiguration.filter(
              (i) => i.DisplayStatus === 1 && i.AdmFormGroupSectionId === 5
            ).length > 0 && (
              <div>
                <h5 className="inner-title  mb-4">
                  Details of In-service Candidates (for those working in
                  Institute)
                </h5>
                <div className="row">
                  <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label>Name Of The Department</label>
                      <input
                        type="text"
                        className="form-control"
                        id="nameOfDepartment"
                        value={
                          textToCapitalize(this.state.nameOfDepartment) || ""
                        }
                        name="nameOfDepartment"
                        label="Department"
                        onChange={this.onInputChange}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label>Name Of The Institution/College</label>
                      <input
                        type="text"
                        className="form-control"
                        id="institution"
                        value={textToCapitalize(this.state.institution) || ""}
                        name="institution"
                        label="Institution/College"
                        onChange={this.onInputChange}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label>Date Of Appointment</label>
                      <DatePicker
                        selected={this.state.dateOfAppointment}
                        onChange={this.appointmentDate}
                        showYearDropdown
                        showMonthDropdown
                        className="form-control"
                        label="Date Of Appointment"
                        dateFormat={this.props.systemConfig.DateFormat}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label>Present Designation</label>
                      <input
                        type="text"
                        className="form-control"
                        id="designation"
                        value={textToCapitalize(this.state.designation) || ""}
                        name="designation"
                        label="Present Designation"
                        onChange={this.onInputChange}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label>Period of Service</label>
                      <input
                        type="number"
                        className="form-control"
                        id="periodOfService"
                        value={this.state.periodOfService || ""}
                        name="periodOfService"
                        label="Period of Service"
                        onChange={this.onInputChange}
                        //validations={[validations.required]}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label>Is NOC Enclosed?</label>
                      <br />
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={this.state.isNOCenclosed ? true : false}
                          name="isNOCenclosed"
                          onChange={this.onSwitchToggle}
                        />
                        <span className="slider round" />
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {this.props.admissionFormConfiguration.filter(
              (i) => i.DisplayStatus === 1 && i.AdmFormGroupSectionId === 6
            ).length > 0 && (
              <div>
                <h2 className="page-title sub-title">Other Details</h2>
                <div className="row mb-3">
                  <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label className="required">Applying Through</label>
                      <SelectAdvance
                        id="selectedQuota"
                        name="selectedQuota"
                        multi
                        className="advanceSelect"
                        onChange={this.handleQuotaChange}
                        label="Quota"
                        value={this.state.selectedQuota}
                        options={this.state.academicQuota}
                      />
                      {this.state.selectedQuotaRequired && (
                        <span className="require_field">
                          Applying Through is Required
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label>Do you need Hostel Accommodation?</label>
                      <br />
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={this.state.isHostel ? true : false}
                          name="isHostel"
                          onChange={this.onSwitchToggle}
                        />
                        <span className="slider round" />
                      </label>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <label>Do you need Transport Facility?</label>
                      <br />
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={this.state.isTransport ? true : false}
                          name="isTransport"
                          onChange={this.onSwitchToggle}
                        />
                        <span className="slider round" />
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {this.props.admissionFormConfiguration.filter(
              (i) => i.DisplayStatus === 1 && i.AdmFormGroupSectionId === 4
            ).length > 0 && (
              <div>
                <h2 className="page-title sub-title">Document Check List</h2>{" "}
                <span className="noteTextRed">
                  Maximum file size to upload 500KB
                </span>
                <table className="table table-bordered qulification-table mb-4">
                  <thead className="table-light">
                    <tr>
                      <th className="align-middle">Document Name</th>
                      <th className="align-middle">Uploaded Document</th>
                      <th className="align-middle">Upload Document</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.allDocumentList.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td
                            className="align-middle filesDocumentName"
                            style={{ width: "450px" }}
                          >
                            <label
                              className="checkbox-inline"
                              htmlFor={item.DocumentCheckListName + index}
                            >
                              {item.DocumentCheckListName}
                            </label>
                            {item.documentFlag === 1 && (
                              <span className="required-docs " />
                            )}
                          </td>
                          <td className="align-middle ">
                            {item.UploadedDocName !== "" && (
                              <a
                                href={keys.ServicePath + item.UploadedDocPath}
                                download="filename"
                                target="_blank"
                                className="download-file"
                              >
                                <span className="uploadDocFileName">
                                  {item.UploadedDocName}{" "}
                                  <i
                                    className="fa fa-cloud-download"
                                    aria-hidden="true"
                                  />
                                </span>
                              </a>
                            )}
                          </td>
                          <td
                            style={{ width: "250px" }}
                            className="align-middle "
                          >
                            <div className="documentBrowse">
                              {/* FileInput */}
                              <FileInput
                                className="form-control-file"
                                id={"file" + index}
                                ref={(c) => {
                                  this["file" + index] = c;
                                }}
                                aria-describedby="fileHelp"
                                name={"file" + index}
                                label="File"
                                validations={
                                  item.documentFlag === 1 &&
                                  !item.UploadedDocPath
                                    ? [
                                        validations.required,
                                        validations.filesize(512000),
                                      ]
                                    : [validations.filesize(512000)]
                                }
                                fileSize={
                                  this.state["file" + index + "fileSize"]
                                }
                                onChange={this.handleFileBrowseChange.bind(
                                  this,
                                  index
                                )}
                                accept="doc,docx,xls,xlsx,ppt,pptx,jpg,jpeg,png"
                              />
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
            {this.props.admissionFormConfiguration.length > 0 && (
              <div className="row">
                <div className="col-lg-12">
                  <NavLink
                    className="btn btn-danger btn-lg theme-btn d-inline"
                    to={`/Account/StudentAccount/AdmissionForm/1/${this.props.FormId}`}
                  >
                    <i className="fa fa-angle-left" aria-hidden="true" />
                    Back
                  </NavLink>

                  {this.props.admissionFormConfiguration.length > 0 && (
                    <div className="d-inline">


                      {this.props.admissionVerifyDetails.length > 0 ?
                      
                    this.props.admissionVerifyDetails[0].IsFormFeesPaid === 0 ?

                    <Link
                    to={`/Account/StudentAccount/AdmissionForm/3/${this.props.admissionVerifyDetails[0].AdmFormGroupId}`}
                    className="btn btn-success btn-lg theme-btn"
                  >
                     Next
                    </Link>

                    :

                    <Button
                          type="submit"
                          className="btn btn-success btn-lg theme-btn"
                        >
                          <i className="fa fa-save" />
                          Save
                        </Button>
                    :
                          <Button
                          type="submit"
                          className="btn btn-success btn-lg theme-btn"
                        >
                          <i className="fa fa-save" />
                          Save
                        </Button>

                    }
                      {/* {this.props.admissionFormList.length > 0 &&
                      this.props.admissionFormList.filter((i) => {
                        return (
                          i.ID === parseInt(this.props.FormId, 10) &&
                          i.IsVerify === 1 &&
                          i.IsActive === 0
                        );
                      }).length > 0 ? (
                        <Link
                          to={`/Account/StudentAccount/AdmissionForm/3/${this.props.FormId}`}
                          className="btn btn-success btn-lg theme-btn"
                        >
                          <i className="fa fa-save" />
                          Save
                        </Link>
                      ) : (
                        <Button
                          type="submit"
                          className="btn btn-success btn-lg theme-btn"
                        >
                          <i className="fa fa-save" />
                          Save
                        </Button>
                      )} */}
                    </div>
                  )}
                </div>
              </div>
            )}
          </Form>
        </div>
      </div>
    );
  }
}

function mapStateToProps({
  auth,
  update,
  qualificationConfigList,
  systemConfig,
  documentChecklist,
  quotaList,
  admissionProgram,
  admissionFormConfiguration,
  admissionSubjectGroupList,
  admissionExperienceDetails,
  admissionOtherDetails,
  admissionResearchDetails,
  admissionWorkingDetails,
  academicQuotaList,
  admissionVerifyDetails,
  admissionApplyThrough,
  admissionBoard,
  admissionMedium,
  admissionMarksType,
  admissionACPCdetails,
  admissionFormList,
  admissionStudentStatusDetails,
  internshipDetails,
  entranceExaminationDetails,
  degreeRegistrationDetails,
  admissionFormLookups,
  neetDetails,
}) {
  return {
    auth,
    update,
    qualificationConfigList,
    systemConfig,
    documentChecklist,
    quotaList,
    admissionProgram,
    admissionFormConfiguration,
    admissionSubjectGroupList,
    admissionExperienceDetails,
    admissionOtherDetails,
    admissionResearchDetails,
    admissionWorkingDetails,
    academicQuotaList,
    admissionVerifyDetails,
    admissionApplyThrough,
    admissionBoard,
    admissionMedium,
    admissionMarksType,
    admissionACPCdetails,
    admissionFormList,
    admissionStudentStatusDetails,
    internshipDetails,
    entranceExaminationDetails,
    degreeRegistrationDetails,
    admissionFormLookups,
    neetDetails,
  };
}
export default connect(mapStateToProps, {
  clearUpdate,
  getQualificationConfigurationByFormId,
  getAllDocumentChecklistByFormId,
  admissionAcademicProfileInsert,
  getAllQuota,
  getAllAdmissionProgramByFormId,
  getAllAdmissionFormConfigurationByFormId,
  getAllAdmissionSubjectGroupByFormId,
  getWorkingInstituteDetailsByStudentId,
  getOtherDetailsByStudentId,
  getResearchDetailsByStudentId,
  getExperienceDetailsByStudentId,
  getAcademicQuotaDetailsByStudentId,
  getFormVerifyDetailsByStudentId,
  getAllApplyThroughList,
  getAllBoardList,
  getAllMediumList,
  getAllMarksTypeList,
  getACPCdetailsByStudentId,
  getAllAdmissionFormListByStudentId,
  getStudentStatusDetailsByUserId,
  getInternshipDetails,
  getEntranceExaminationDetails,
  getDegreeRegistrationDetails,
  getAdmissionFormLookups,
  getNeetDetails,
})(AcademicInfo);



// WEBPACK FOOTER //
// ./src/components/StudentAccount/AcademicInfo.js